const TRACKER_MANAGEMENT_EXPERIENCE_TYPES = {
  CREATE: '[trackerManagementExperience] createTracker',
  SET_CREATED: '[trackerManagementExperience] setCreated',
  FETCH_DETAILS: '[trackerManagementExperience] fetchTrackerDetails',
  EDIT: '[trackerManagementExperience] editTracker',
  DELETE: '[trackerManagementExperience] deleteTracker',
  OPEN_TRACKER_CONTROL_PANEL: '[trackerManagementExperience] openTrackerControlPanel',
  CLOSE_TRACKER_CONTROL_PANEL: '[trackerManagementExperience] closeTrackerControlPanel',
  SEND_OUTPUT_TO_TRACKER: '[trackerManagementExperience] sendOutputToTracker',
  LISTEN: '[trackerManagementExperience] listenTracker',
  UPDATE_ATTRIBUTE_ACTIVE: '[trackerManagementExperience] updateAttributeActive',
  DETACH_USER: '[trackerManagementExperience] detachUser',
  SEND_COMMAND: '[trackerManagementExperience] sendCommand',
  FETCH_LOCATION_STRING_FOR_COORDINATE: '[trackerManagementExperience] fetchLocationStringForCoordinate'
}

export default TRACKER_MANAGEMENT_EXPERIENCE_TYPES

